export default "__VITE_ASSET__CfS6zN40__"